import {
  AIR, ARCTIC_TRUCK, CONNECTION_ID, DISTANCE, FROM_NAME, FROM_TYPE, FROM_UNIT_ID,
  MONETARY_VOLUMES, QUANTITY, RAIL, RIGID_TRUCK, SEA, TRUCK, UNIT_CURRENCY,
  UNIT_MONETARY_VOLUMES, VAN,
} from 'constants/formFields';

import type { IGoodsSupplierConnection } from 'store/slices/valueChainMap/interfaces/IGoodsSupplierConnection';

// The form models transport as one checkbox per method; the payload carries the chosen ones as
// an array. Both directions read this list so they cannot drift apart.
export const TRANSPORT_FIELDS = [AIR, SEA, RAIL, VAN, TRUCK, RIGID_TRUCK, ARCTIC_TRUCK] as const;

// The enum selector builds every option as `{ label: value, value }`, so a stored value needs no
// lookup to become the option a Select renders. An empty object rather than `undefined` for the
// unset case, matching what the schema infers for these conditionally required selects.
const toOption = (value: string | null) => (value ? { value, label: value } : {});

const toNumericString = (value: number | null) => (
  value || value === 0 ? `${value}` : ''
);

// Turns the connections a record GET returned into form rows. The `from` summary is flattened
// onto the row for the chip and dropped again on the way out, since the request DTO whitelists
// its properties and rejects anything else.
const goodsSupplierConnectionsFormatted = (
  connections: IGoodsSupplierConnection[],
) => connections.map((connection) => ({
  [CONNECTION_ID]: connection.id,
  [FROM_UNIT_ID]: connection.fromUnitId,
  [FROM_NAME]: connection.from?.name || '',
  [FROM_TYPE]: connection.from?.type || '',
  ...TRANSPORT_FIELDS.reduce<Record<string, boolean>>((acc, field) => ({
    ...acc,
    [field]: Boolean(connection.transportMethods?.includes(field)),
  }), {}),
  [DISTANCE]: connection.distance || '',
  [MONETARY_VOLUMES]: toNumericString(connection.monetaryValue),
  [UNIT_MONETARY_VOLUMES]: toOption(connection.monetaryCurrency),
  [QUANTITY]: toNumericString(connection.quantity),
  [UNIT_CURRENCY]: toOption(connection.quantityUnit),
}));

export default goodsSupplierConnectionsFormatted;
